import { Box, IconButton, Typography } from "@mui/material"
import { icons } from "../../../../../../utils/icons"

interface ColumnProps {
  styles: any
  redirectToUnitDetail: (params: { row?: any }) => void
}

export const getColumns = ({ styles, redirectToUnitDetail }: ColumnProps) => [
  {
    id: 'id',
    label: `ID - Unidad`,
    headerCell: {
      pl: '1rem',
      minWidth: '200px'
    },
    rowTdStyles: {
      pl: '1rem',
      minWidth: '200px',
      textAlign: 'center'
    }
  },
  {
    id: 'programQuestionnaires',
    label: (
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1.2 }}>
        <span>Cuestionarios</span>
        <span>programados</span>
      </Box>
    ),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      minWidth: '120px',
      textAlign: 'center'
    },
    headerCell: {
      minWidth: '120px'
    },
    renderCell: (params: any) => (
      <Typography sx={styles.cell}>
        {params.row.programQuestionnaires}
      </Typography>
    )
  },
  {
    id: 'percentageAdvanceQuestions',
    label: (
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1.2 }}>
        <span>Porcentaje avance</span>
        <span>de preguntas</span>
      </Box>
    ),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      minWidth: '140px',
      textAlign: 'center'
    },
    headerCell: {
      minWidth: '140px'
    },
    renderCell: (params: any) => (
      <Typography sx={styles.cell}>
        {params.row.percentageAdvanceQuestions}
      </Typography>
    )
  },
  {
    id: 'questionnairesInProcess',
    label: (
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1.2 }}>
        <span>Cuestionarios</span>
        <span>en Proceso</span>
      </Box>
    ),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      minWidth: '130px',
      textAlign: 'center'
    },aderCell: {
      minWidth: '130px'
    },
    renderCell: (params: any) => (
      <Typography sx={styles.cell}>
        {params.row.questionnairesInProcess}
      </Typography>
    )
  },
  {
    id: 'completedQuestionnaires',
    label: (
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1.2 }}>
        <span>Cuestionario</span>
        <span>finalizado</span>
      </Box>
    ),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      minWidth: '130px'
    },
    headerCell: {
      minWidth: '130px',
      textAlign: 'center'
    },
    renderCell: (params: any) => (
      <Typography sx={styles.cell}>
        {params.row.completedQuestionnaires}
      </Typography>
    )
  },
  {
    id: 'resultAverage',
    label: (
      <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1.2 }}>
        <span>Promedio de</span>
        <span>Resultados</span>
      </Box>
    ),
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      minWidth: '130px',
      textAlign: 'center'
    },
    headerCell: {
      textAlign: 'center',
      minWidth: '130px'
    },
    renderCell: (params: any) => (
      <Typography sx={styles.cell}>
        {params.row.resultAverage}
      </Typography>
    )
  },
  {
    id: 'actions',
    contentColumn: { justifyContent: 'center' },
    rowTdStyles: {
      maxWidth: '100px',
      textAlign: 'center'
    },
    headerCell: {
      maxWidth: '100px',
      textAlign: 'center'
    },
    renderCell: (params: any) => {
      return <IconButton sx={{ transform: 'scaleX(-1)' }} onClick={() => {
        redirectToUnitDetail({ row: params.row })
      }}>{icons('reply')}</IconButton>
    }
  }
]

export const exportColumns = [
  {
    id: 'id',
    label: 'ID - Unidad'
  },
  {
    id: 'programQuestionnaires',
    label: 'Cuestionarios programados'
  },
  {
    id: 'percentageAdvanceQuestions',
    label: 'Porcentaje avance de preguntas'
  },
  {
    id: 'questionnairesInProcess',
    label: 'Cuestionarios en Proceso'
  },
  {
    id: 'completedQuestionnaires',
    label: 'Cuestionarios finalizados'
  },
  {
    id: 'resultAverage',
    label: 'Promedio de Resultados'
  }
]